(function () {

    'use strict';

    angular.module('iplusjs.utils.tracking', [
        'lodash',
        'libphonenumber',
        'angulartics',
        'iplusjs.utils.misc'
    ])
        .service('TrackingUtilsService', TrackingUtilsService);

    TrackingUtilsService.$inject = [
        '$rootScope',
        '$window',
        '$location',
        '$q',
        '$injector',
        '$log',
        'lodash',
        'libphonenumber',
        '$timeout',
        '$analytics',
        'MiscUtilsService',
        'AppConfig'
    ];
    function TrackingUtilsService($rootScope, $window, $location, $q, $injector, $log, _, libphonenumber, $timeout, $analytics, MiscUtilsService, AppConfig) {
        var that = this;

        that.normalizeEmail = normalizeEmail;
        that.normalizePhoneNumber = normalizePhoneNumber;
        that.trackFormControls = trackFormControls;
        that.triggerChangeEvent = triggerChangeEvent;
        that.getFormControlsName = getFormControlsName;
        that.trackDefaultEvent = trackDefaultEvent;
        that.resetTrackingCache = resetTrackingCache;
        that.trackVertragsabschluss = trackVertragsabschluss;

        $rootScope.$on('iplusjs:tracking:trackDefaultEvent', function (event, data) {
            $timeout(function () {
                trackDefaultEvent(data.action, data.trackingProvider, _.size(data.trackingElements) > 0 ? data.trackingElements : getFormControlsName(data.formCtrl), data.formCtrl);
            }, 500);
        });

        $rootScope.$on('iplusjs:tracking:triggerChangeEvent', function (event, trackingElements, properties) {
            triggerChangeEvent(trackingElements, properties);
        });
        function normalizeEmail(trackingProvider, email) {
            var normalizedEmail = _.trim(email) || '',
                emailParts;

            if (trackingProvider === 'hurra') {
                normalizedEmail = _.toLower(_.trim(normalizedEmail));
                emailParts = normalizedEmail.split('@');

                if (emailParts.length > 1 && /^(gmail|googlemail)\.com\s*/.test(emailParts[1])) {
                    emailParts[0] = _.replace(emailParts[0], /\./g, '');
                    normalizedEmail = _.join(emailParts, '@');
                }
            }

            return normalizedEmail;
        }
        function normalizePhoneNumber(trackingProvider, phoneNumber) {
            var normalizedPhoneNumber = _.trim(phoneNumber) || '';

            if (trackingProvider === 'hurra') {
                try {
                    normalizedPhoneNumber = libphonenumber.parsePhoneNumber(phoneNumber, 'DE').number;
                } catch (e) {
                }
            }

            return normalizedPhoneNumber;
        }
        function trackFormControls(scope, form) {
            scope._elChangeDetection = {};

            $log.debug('TrackingUtilsService.trackFormControls', form);

            form = form || {};
            function _changeDetection(event) {
                var control = form[_.get(event, 'currentTarget.name') || _.get(event, 'detail.trackingProperties.name')];

                if (!control) {
                    return;
                }
                if (event && _.get(event, 'detail.forceTracking') === true) {
                    _trackControl(control, _.get(event, 'detail'));
                } else {
                    scope._elChangeDetection[control.$name] = true;
                }
            }
            function _blurDetection(event) {
                var control = form[_.get(event, 'currentTarget.name')];

                if (!control) {
                    return;
                }

                _trackControl(control, _.get(event, 'detail'));
            }

            function _trackControl(control, options) {
                var value;

                options = options || {};

                if (!control) {
                    return;
                }

                if (_.get(options, 'forceTracking') === true || scope._elChangeDetection[control.$name] === true) {
                    if (control.$pending) {
                        setTimeout(function () {
                            _trackControl(control, options);
                        }.bind(this, control, options), 500);
                    } else {
                        value = MiscUtilsService.getValueCustomObject(control.$modelValue || control.$viewValue);

                        if (_.isObject(value)) {
                            value = JSON.stringify(value);
                        }

                        $analytics.eventTrack('input', {
                            trackingProvider: 'wgv',
                            element: control.$$element[0],
                            value: value,
                            target: control.$name,
                            state: _.get(options, 'trackingProperties.state') || getFormControlState(control.$$element[0], null, control),
                            force: !_.isNil(_.get(options, 'trackingProperties.force')) ? _.get(options, 'trackingProperties.force') : false
                        });
                        scope._elChangeDetection[control.$name] = false;
                    }
                }
            }
            function _clickDetection(event) {
                var el = _.get(event, 'currentTarget');

                if (!el) {
                    return;
                }
                el.focus();
            }

            scope.$watchCollection(function () {
                return form.$$controls;
            }, function (newValue, oldValue) {
                angular.element(function () {
                    $log.debug('TrackingUtilsService.trackFormControls watch form.$$controls', getFormControlsName(form), form);
                    trackDefaultEvent('input', 'wgv', getFormControlsName(form), form);
                });

                $timeout(function () {
                    _.forEach(form.$$controls, function ($control) {
                        $control.$$element[0].removeEventListener('change', _changeDetection);
                        $control.$$element[0].addEventListener('change', _changeDetection);

                        $control.$$element[0].removeEventListener('blur', _blurDetection);
                        $control.$$element[0].addEventListener('blur', _blurDetection);

                        $control.$$element[0].removeEventListener('click', _clickDetection);
                        $control.$$element[0].addEventListener('click', _clickDetection);
                    });
                });
            });
        }
        function triggerChangeEvent($elements, properties) {
            $timeout(function () {
                $elements = $elements || [];
                properties = properties || {};

                var customEvent = new CustomEvent('change', {
                    detail: {
                        forceTracking: true,
                        trackingProperties: properties
                    }
                });

                _.forEach($elements, function ($element) {
                    if ($element) {
                        if (properties.name) {
                            customEvent.detail.name = properties.name;
                        }
                        $element[0].dispatchEvent(customEvent);
                    }
                });
            });
        }
        function trackDefaultEvent(action, trackingProvider, trackingElements, formCtrl) {
            var control,
                formControls,
                untouched,
                dirty,
                value,
                element;

            $timeout(function () {
                _.forEach(trackingElements, function (trackingElement) {
                    if (action === 'input' && formCtrl && trackingElement && formCtrl[trackingElement.name] && formCtrl[trackingElement.name].$$element[0]) {
                        formControls = _.filter(formCtrl.$getControls(), function (c) {
                            return c.$name === trackingElement.name;
                        });
                        control = formCtrl[trackingElement.name];
                        element = control.$$element[0];
                        value = MiscUtilsService.getValueCustomObject(control.$modelValue || control.$viewValue);

                        if (_.isObject(value)) {
                            value = JSON.stringify(value);
                        }

                        untouched = _.every(formControls, function (c) {
                            return c.$untouched;
                        });
                        dirty = _.some(formControls, function (c) {
                            return c.$dirty;
                        });

                        $log.debug('TrackingUtilsService.trackDefaultEvent', trackingElement, value, untouched, dirty, control, element, formCtrl);
                        if (MiscUtilsService.isNotEmpty(value) && untouched && !dirty) {
                            $analytics.eventTrack(action, {
                                trackingProvider: trackingProvider,
                                element: element,
                                value: value,
                                target: element.name,
                                state: trackingElement.state || getFormControlState(element, 'default', control)
                            });
                        }
                    } else if (trackingElement && trackingElement.name) {
                        $analytics.eventTrack(action, {
                            trackingProvider: 'wgv',
                            target: trackingElement.name,
                            value: trackingElement.value,
                            state: trackingElement.state || 'default'
                        });
                    }
                });
            });
        }

        function getFormControlsName(formCtrl) {
            if (!formCtrl || !_.size(formCtrl.$$controls)) {
                return [];
            }

            return _.uniq(_.compact(_.map(formCtrl.$$controls, function (control) {
                return {
                    name: control.$name
                };
            })));
        }
        function getFormControlState(element, normalState, control) {
            element = element || {};
            normalState = normalState || 'normal';

            var $formElement;

            if (control) {
                $formElement = _.get(control, '$$parentForm.$$element');

                if ($formElement) {
                    if (_.get($formElement.find('fieldset')[0], 'disabled') === true) {
                        return 'unchangeable';
                    }
                }
            }

            return (element.disabled || element.readonly) ? 'unchangeable' : normalState;
        }

        function resetTrackingCache(trackingProvider) {
            if (trackingProvider === 'wgv') {
                if ($window._wgvt) {
                    $window._wgvt._trackingCache = [];
                }
            }
        }

        function trackVertragsabschluss(angebotModel) {
            var AngebotUtilsService = $injector.get('AngebotUtilsService'),
                BasisAngebotService = $injector.get('BasisAngebotService'),
                gesamtbeitrag = BasisAngebotService.getGesamtbeitragZuZahlweise(angebotModel.angebot, '51'),
                hemParam,
                hphParam;
            if (_.includes($analytics.settings.pageTracking.excludedRoutes, $location.url())) {
                $analytics.eventTrack('sale', {
                    trackingProvider: 'etracker',
                    path: $location.url(),
                    target: 'Sale',
                    val: '1',
                    sale: 1
                });
            }

            $analytics.eventTrack('sale', {
                trackingProvider: 'wgv',
                target: 'vertragsabschluss'
            });
            $q.all([
                MiscUtilsService.hashMessage(normalizeEmail('hurra', _.get(angebotModel, 'formData.antragsteller.emailPrivat.wert', '')), 'SHA-256'),
                MiscUtilsService.hashMessage(normalizePhoneNumber('hurra', _.get(angebotModel, 'formData.antragsteller.telefonMobil.wert', '')), 'SHA-256')
            ]).then(function (result) {
                hemParam = result[0];
                hphParam = result[1];
            }).catch(function (error) {
            }).finally(function () {
                $analytics.eventTrack('confirmation', {
                    trackingProvider: 'hurra',
                    category_id: 'ICISPlus-Angebot',
                    product_id: BasisAngebotService.getAngebotstyp(angebotModel.angebot),
                    product_quantity: 1,
                    amount: _.get(gesamtbeitrag, 'amount'),
                    u5: AngebotUtilsService.getTrackingParameter(angebotModel.angebot, 'hurra', 'confirmation', 'u5', 'sale'),
                    hem: hemParam,
                    hph: hphParam
                });
            });

        }
    }

})();
